// Bridge between Clerk's useAuth().getToken() (hook-only) and the plain axios
// module in lib/api.js. A ClerkTokenBridge component registers the real
// getter once Clerk has loaded; until then (or if Clerk isn't signed in)
// this returns null and callers fall back to the legacy token.
let tokenGetter = async () => null;

export const registerTokenGetter = (fn) => {
  tokenGetter = fn;
};

export const getAuthToken = () => tokenGetter();
